export const LOGOUT = 'LOGOUT';

export const LogoutAction = () => async (dispatch) => {
    dispatch({
        type: LOGOUT,
    })
}
